function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == typeof e || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import * as React from 'react';
import ModalWrapper from '../../Modal/ModalWrapper/ModalWrapper';
import ErrorModal from '../ErrorModal/ErrorModal';
import ErrorFormatter from '../ErrorFormatter/ErrorFormatter';
var ErrorModalHandler = /*#__PURE__*/function (_React$Component) {
  _inherits(ErrorModalHandler, _React$Component);
  function ErrorModalHandler() {
    _classCallCheck(this, ErrorModalHandler);
    return _possibleConstructorReturn(this, _getPrototypeOf(ErrorModalHandler).apply(this, arguments));
  }
  _createClass(ErrorModalHandler, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        error = _this$props.error,
        children = _this$props.children,
        removeError = _this$props.removeError,
        alertTitleKey = _this$props.alertTitleKey,
        i18nPrefix = _this$props.i18nPrefix,
        defaultI18nKey = _this$props.defaultI18nKey;
      if (error) {
        return /*#__PURE__*/React.createElement(ErrorFormatter, {
          error: error,
          i18nPrefix: i18nPrefix,
          defaultI18nKey: defaultI18nKey
        }, function (formattedError) {
          return /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement(ModalWrapper, {
            defaultMounted: true
          }, function (_ref) {
            var mounted = _ref.mounted,
              triggerClose = _ref.triggerClose;
            return /*#__PURE__*/React.createElement(ErrorModal, {
              alertTitleKey: alertTitleKey,
              mounted: mounted,
              triggerClose: triggerClose,
              formattedErrors: formattedError,
              removeError: removeError
            });
          }));
        });
      } else {
        return children;
      }
    }
  }]);
  return ErrorModalHandler;
}(React.Component);
export { ErrorModalHandler as default };